<template>
  <div style="height: 100%;">
    <enfold-uc>
      <template slot="up">
        <div class="c-u-left">网页小工具</div>
        <div class="c-u-right">
          <el-button size="mini" type="primary" @click="()=>{dialogVisible=!dialogVisible}">网页工具上传</el-button>
        </div>
      </template>
      <template slot="center">
        <div class="wt-center">
          <web-tool-list v-for="(list,theme) in tools" :key="theme" :theme="theme" :list="list" @handleTool="handleTool"></web-tool-list>
        </div>
      </template>
    </enfold-uc>
    <form-dialog title="网页工具" :dialogVisible="dialogVisible" @closeDialog="closeDialog">
      <add-web-tool @closeAddTool="closeDialog" :tools="tools"></add-web-tool>
    </form-dialog>
  </div>
</template>

<script>
import EnfoldUc from '@/components/basics/EnfoldUC'
import FormDialog from '@/components/basics/FormDialog'
import AddWebTool from '../children/AddWebTool'
import WebToolList from '../children/WebToolList'

export default {
  name: 'WebTools',
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      uploadFile: {},
      uploadImages: {},
      imageUrl: '',
      tools: {}
    };
  },
  components: {
    EnfoldUc,
    FormDialog,
    AddWebTool,
    WebToolList
  },

  created() {
    this.getWebToolList();
  },
  methods: {
    handleTool(id) {
      this.$http.post('/admin/material/delWebTool', { ids: id }, () => {
        this.$msg({ showClose: true, message: '删除成功!', type: 'success' });
        this.getWebToolList();
      })
    },
    getWebToolList() {
      this.$http.post('/admin/material/getWebToolList', {}, (res) => {
        // console.log(res);
        this.tools = res;
      })
    },
    closeDialog(confirm) {
      if (confirm) {
        this.getWebToolList();
      }
      this.dialogVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>